const mobileDetection = {
	any: function() {
		return window.innerWidth < 648;
	}
};

export default mobileDetection;